import { render, staticRenderFns } from "./DivasSocials.vue?vue&type=template&id=11c441d2&scoped=true&"
import script from "./DivasSocials.vue?vue&type=script&lang=js&"
export * from "./DivasSocials.vue?vue&type=script&lang=js&"
import style0 from "./DivasSocials.vue?vue&type=style&index=0&id=11c441d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c441d2",
  null
  
)

export default component.exports